/*
 * A sequence carries no status until it is explicitly moved: a running one has
 * status null, and the API only ever sets DRAFT / PAUSED / DELETED / SUSPENDED.
 * Checking `status === "ACTIVE"` therefore matched nothing, which made the
 * sequence rules read every workspace as "nothing is sending".
 *
 * PAUSED counts as inactive here even though the backend's inbox-usage endpoint
 * counts it as active -- the findings treat paused separately ("paused means
 * nothing sends"), and a paused sequence is not sending by any reading.
 */
const INACTIVE = ["DRAFT", "PAUSED", "DELETED", "SUSPENDED", "ARCHIVED"];

const sequenceStatus = seq =>
  String(seq?.status || seq?.background?.status || "").toUpperCase();

const isSequenceActive = seq => !INACTIVE.includes(sequenceStatus(seq));

export default isSequenceActive;
export { sequenceStatus, INACTIVE };
